module.exports = __webpack_public_path__ + "img/logo_en.d84eb12d.png";